export default __webpack_public_path__ + "static/media/thumb-up.38ea473c.svg";